import { Auth } from '../../utils/auth';

const { token, user } = Auth.getStorageData();

export default {
    auth: {
        token,
        user
    },
}